import { $$_create_walker, $$_attr, $$_hydrating, $$_create_template } from 'maverick.js/dom';

const $$_templ = /* @__PURE__ */ $$_create_template(`<!$><svg viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false" data-media-icon="true"></svg>`);
function Icon({ slot, part, paths, rotate }) {
  return (() => {
    const [$$_root, $$_walker] = $$_create_walker($$_templ);
    $$_attr($$_root, "data-rotate", rotate);
    $$_attr($$_root, "slot", slot);
    $$_attr($$_root, "part", part);
    if (!$$_hydrating)
      $$_root.innerHTML = paths;
    return $$_root;
  })();
}

export { Icon as I };
